import { Platform, StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';
import type { ThemeMode } from '../../../src/theme/ThemeContext';

const PICK_COL_WIDTH = 76;
const PICK_MID_WIDTH = 32;

export const getMatchCardPickRowStyles = (theme: Theme, themeMode: ThemeMode = 'light') => {
  const isDark = themeMode === 'dark';
  const minusBtnBg = isDark ? theme.gray[300] : theme.gray[200];

  return StyleSheet.create({
    matrix: {
      flexGrow: 0,
      flexShrink: 0,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 0,
      width: PICK_COL_WIDTH + PICK_MID_WIDTH + PICK_COL_WIDTH,
    },
    gridRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    pickCol: {
      width: PICK_COL_WIDTH,
      alignItems: 'center',
    },
    pickColMid: {
      width: PICK_MID_WIDTH,
      alignItems: 'center',
    },
    scoreLineMargin: {
      marginBottom: 4,
    },
    scoreBox: {
      minWidth: 52,
      height: 60,
      borderRadius: 14,
      alignItems: 'center',
      justifyContent: 'center',
      borderWidth: isDark ? 0 : 1,
      borderColor: isDark ? 'transparent' : theme.gray[200],
      backgroundColor: isDark ? theme.background.inset : theme.white,
      shadowColor: isDark ? '#000' : theme.black,
      shadowOpacity: isDark ? 0.5 : 0.08,
      shadowRadius: isDark ? 12 : 8,
      shadowOffset: { width: 0, height: isDark ? 2 : 3 },
      elevation: isDark ? 5 : 2,
    },
    scoreNum: {
      fontSize: 34,
      fontWeight: '900',
      color: isDark ? theme.white : theme.gray[900],
      textAlign: 'center',
    },
    monkeyBadgeRow: {
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 3,
    },
    monkeyBadge: {
      paddingHorizontal: 8,
      paddingVertical: 3,
      borderRadius: 999,
      backgroundColor: isDark ? theme.gray[800] : theme.gray[100],
      color: isDark ? theme.gray[100] : theme.gray[800],
      fontSize: 9,
      fontWeight: '900',
      letterSpacing: 0.2,
      textAlign: 'center',
      overflow: 'hidden',
    },
    vsText: {
      fontSize: 14,
      fontWeight: '800',
      color: isDark ? 'rgba(255,255,255,0.7)' : theme.gray[600],
      textTransform: 'lowercase',
      textAlign: 'center',
    },
    btnRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 4,
    },
    /** Same pattern as CorrectScorePicker (exact score): minus = neutral chip, plus = primary. */
    scoreBtn: {
      width: 32,
      height: 32,
      borderRadius: 8,
      justifyContent: 'center',
      alignItems: 'center',
    },
    scoreBtnMinus: {
      backgroundColor: minusBtnBg,
    },
    scoreBtnPlus: {
      backgroundColor: theme.primary,
    },
    scoreBtnDisabled: {
      opacity: 0.4,
    },
    scoreBtnPressed: {
      opacity: 0.88,
      transform: [{ scale: 0.96 }],
    },
    scoreBtnHover: {
      ...(Platform.OS === 'web' && {
        opacity: 0.92,
      }),
    },
  });
};
